// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-input[data-v-caec11e6] {\n  width: 400px;\n}\n", ""]);
// Exports
module.exports = exports;
